import styles from './InvestigationNotification.module.scss';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { InvestigationStatus } from '@customer/store/apis/investigationsApi';
import { VdsLink, VdsNotification } from '@volt/volt-extended-components-react';
import { TranslationNamespaceBackend } from '@cas/utils/translationHelpers';
import { useAppSelector } from '@customer/store/hooks';
import { Permission, userHasPermission } from '@customer/permissions';
import { Link } from 'react-router-dom';

interface InvestigationNotificationProps {
  investigationId: number;
  status: InvestigationStatus;
  onContinue: () => void;
}

export const InvestigationNotification = ({
  investigationId,
  status,
  onContinue,
}: InvestigationNotificationProps): ReactElement => {
  const { t } = useTranslation();

  const userData = useAppSelector(state => state.auth);

  return (
    <div className={styles.container}>
      <VdsNotification
        variant="inline"
        status="informative"
        icon="information"
        showCloseButton={false}
      >
        <div slot="header" className={styles.header}>
          {t('InvestigationStatus')}
        </div>
        <div slot="body" className={styles.status}>
          {t(`Enum.InvSts.${status}`, { ns: TranslationNamespaceBackend })}
        </div>

        {userHasPermission(userData, Permission.InvestigationsAll) && (
          <Link slot="actions" to={`/investigation/${investigationId}`} onClick={onContinue}>
            <VdsLink value={t('Continue')} size="extra-small" underline={true} />
          </Link>
        )}
      </VdsNotification>
    </div>
  );
};

export default InvestigationNotification;
